import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import DealerBalloonClose from "./DealerBallonClose.js";
import DealerBalloonAddress from "./DealerBalloonAddress.js";
import DealerBalloonButtons from "./DealerBalloonButtons.js";
import DealerBalloonForward from "./DealerBalloonForward.js";
import DealerBalloonPhone from "./DealerBalloonPhone.js";
import DealerBalloonTags from "./DealerBalloonTags.js";
import DealerBalloonTitle from "./DealerBalloonTitle.js";
import './DealerBalloon.css';/* empty css                   */
const DealerBalloon = ({ children, className, onClick, id }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classnames("perxis-auto-dealer-balloon", className),
      role: "button",
      tabIndex: 0,
      onClick: onClick ? () => onClick(id) : void 0,
      onKeyUp: onClick ? () => onClick(id) : void 0,
      children
    }
  );
};
DealerBalloon.Title = DealerBalloonTitle;
DealerBalloon.Address = DealerBalloonAddress;
DealerBalloon.Phone = DealerBalloonPhone;
DealerBalloon.Tags = DealerBalloonTags;
DealerBalloon.Forward = DealerBalloonForward;
DealerBalloon.Buttons = DealerBalloonButtons;
DealerBalloon.Close = DealerBalloonClose;
export {
  DealerBalloon as default
};
//# sourceMappingURL=DealerBalloon.js.map
